import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={0} ref={ref} variant="standard" {...props} />;
});

let showSnackbar;

function CustomizedSnackbars() {

  const [[open, message, severity], setOpen] = React.useState([false,"",""]);

  showSnackbar = (m, s) => {
    setOpen([true, m, s]);
  };

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen([false,"",""]);
  };

  return (
    <Snackbar
      anchorOrigin={{vertical:"top", horizontal:"center"}}
      open={open}
      autoHideDuration={4200}
      onClose={handleClose}
    >
      <Alert
        onClose={handleClose}
        severity={(severity||"").length<2?"success": severity}
        sx={{
          width: "fit-content",
          maxWidth: "min(92vw, 620px)",
          fontWeight: 500,
          fontSize: "0.95rem",
          borderRadius: 12,
          border: "1px solid",
          borderColor: "rgba(90, 104, 110, 0.28)",
          backdropFilter: "blur(8px)",
          "&.MuiAlert-standardSuccess": {
            color: "#d3e6de",
            backgroundColor: "rgba(30, 65, 55, 0.82)",
          },
          "& .MuiAlert-icon": {
            color: "inherit",
            opacity: 0.92,
          },
          "& .MuiAlert-message": {
            py: 0.25,
          },
          "& .MuiAlert-action": {
            py: 0,
            pl: 1,
          },
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
export default CustomizedSnackbars;
export {showSnackbar};
